document.addEventListener('DOMContentLoaded', function () {
  var CONFIG = {
    priceSelector: '.o-product__price .m-price-item--sale, .o-product__price .m-price__regular > .m-price-item--regular',
    sizeInputSelector: '.m-variants__input',
    realAtcButtonSelector: '.o-product__product-form .m-product-form__submit',
    actionBarSelector: '.js-action-bar',
    visibleClass: 'm-action-bar--visible',
    footerSelector: '.o-footer'
  };

  var infoEl = document.querySelector('.js-action-bar .m-action-bar__info');
  var combinedEl = null;

  function ensureCombinedElement() {
    if (!infoEl) return null;
    if (combinedEl) return combinedEl;

    var titleEl = infoEl.querySelector('.m-action-bar__title');
    var wrapper = document.createElement('div');
    wrapper.className = 'm-action-bar__text';

    if (titleEl) {
      titleEl.parentNode.insertBefore(wrapper, titleEl);
      wrapper.appendChild(titleEl);
    } else {
      infoEl.appendChild(wrapper);
    }

    combinedEl = document.createElement('span');
    combinedEl.className = 'm-action-bar__combined';
    wrapper.appendChild(combinedEl);

    return combinedEl;
  }

  function getVisiblePriceText() {
    var candidates = document.querySelectorAll(CONFIG.priceSelector);
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].offsetParent !== null) {
        return candidates[i].textContent.trim();
      }
    }
    return '';
  }

  function getSelectedSizeText() {
    var checkedInput = document.querySelector(CONFIG.sizeInputSelector + ':checked');
    if (!checkedInput) return '';

    var label = document.querySelector('label[for="' + checkedInput.id + '"]');
    var variantSpan = label ? label.querySelector('.js-variant') : null;

    return variantSpan ? variantSpan.textContent.trim() : checkedInput.value;
  }

  function sync() {
    var el = ensureCombinedElement();
    if (!el) return;

    var priceText = getVisiblePriceText();
    var sizeText = getSelectedSizeText();

    if (sizeText && priceText) {
      el.innerHTML = sizeText + ' &middot; <strong>' + priceText + '</strong>';
    } else if (priceText) {
      el.innerHTML = '<strong>' + priceText + '</strong>';
    } else {
      el.innerHTML = '';
    }
  }

  sync();

  document.addEventListener('change', function (e) {
    if (e.target.matches(CONFIG.sizeInputSelector)) {
      sync();
    }
  });

  var sizesGrid = document.querySelector('.m-variants__grid');
  if (sizesGrid) {
    var sizesObserver = new MutationObserver(sync);
    sizesObserver.observe(sizesGrid, { childList: true, characterData: true, subtree: true });
  }

  var priceContainer = document.querySelector('.o-product__price');
  if (priceContainer) {
    var priceObserver = new MutationObserver(sync);
    priceObserver.observe(priceContainer, { childList: true, characterData: true, subtree: true });
  }

  var actionBar = document.querySelector(CONFIG.actionBarSelector);
  var realButton = document.querySelector(CONFIG.realAtcButtonSelector);
  if (!actionBar || !realButton) return;

  function buttonIsInView() {
    var rect = realButton.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function isNearBottomOfPage() {
    var distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    return distanceFromBottom <= 100;
  }

  function enforceVisibility() {
    var shouldShow = !buttonIsInView() && !isNearBottomOfPage();

    var hasClass = actionBar.classList.contains(CONFIG.visibleClass);
    if (shouldShow && !hasClass) {
      actionBar.classList.add(CONFIG.visibleClass);
    } else if (!shouldShow && hasClass) {
      actionBar.classList.remove(CONFIG.visibleClass);
    }
  }

  var classObserver = new MutationObserver(enforceVisibility);
  classObserver.observe(actionBar, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('scroll', enforceVisibility, { passive: true });
  window.addEventListener('resize', enforceVisibility);
  enforceVisibility();
});